import React, {Component} from 'react';
import '../../Home.css';

let _this;

class AgentsAtWorkProduct extends Component {

    constructor(props, context) {
        super(props);
        _this = this;

    }

    componentDidMount() {
    }

    render() {
        return <div className="container">
            <div align="center">
                <div className="fast_nav container">
                    <ul>
                        <li className="first">
                            <a href="#" role="button"
                               onClick={() => _this.props.navigate('Products')}>2026 © AnswerSolutions LLC</a>
                        </li>
                        <li className="selected">
                            <a href="#agents-at-work-product" role="button"
                               onClick={() => _this.props.navigate('AgentsAtWorkProduct')}>Agents At Work</a>
                        </li>
                        <li>
                            <a href="https://agentsatwork.app/privacy.html" target="_blank"
                               rel="noopener noreferrer">Privacy Policy</a>
                        </li>
                        <li>
                            <a href="https://agentsatwork.app/terms.html" target="_blank"
                               rel="noopener noreferrer">Terms</a>
                        </li>
                        <li>
                            <a href="https://agentsatwork.app/support.html" target="_blank"
                               rel="noopener noreferrer">Support</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="card" id="shell4">
                <div id="card_content">
                    <div>
                        <img style={{borderRadius: '10%', margin: '0 16px 0 16px'}}
                             className="roundrect"
                             src="/agents_at_work_icon.png"
                             align="left"
                             alt="app icon"
                             width="128"/>
                        <div>
                            <h2>Agents At Work</h2>
                            <h3>Your AI agents are working. You don't have to babysit them.</h3>
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <p>
                        <b>Why you need Agents At Work?</b><br/><br/>
                        Agents At Work is the mobile companion for Claude Code, Codex, Gemini CLI,
                        Grok, Cursor, and local Ollama models running on your Mac. A small
                        background bridge watches your agent sessions and pushes a notification to
                        your phone the moment one needs you &mdash; finishes a task, hits an error, or
                        is waiting on a permission prompt.

                        Approve or deny a tool call with one tap, send a new prompt mid-session, or
                        just check in on progress, all from your phone. Every message is end-to-end
                        encrypted between your Mac and your phone.

                        The Mac app is free, notarized by Apple, and does not require the Mac App
                        Store.
                    </p>
                    <div className="row">
                        <div className="column">
                            <img src="/agents_at_work_1.png" alt="install on macOS" width="100%"/>
                        </div>
                        <div className="column">
                            <img src="/agents_at_work_2.png" alt="push notification and approval" width="100%"/>
                        </div>
                        <div className="column">
                            <img src="/agents_at_work_3.png" alt="session feed" width="100%"/>
                        </div>
                        <div className="column">
                            <img src="/agents_at_work_4.png" alt="sessions list" width="100%"/>
                        </div>
                    </div>
                </div>
                <br/>
                <br/>
                <br/>
                <div className="divider"></div>
                <br/>
                <div style={{margin: '0 24px 0 24px'}}>
                    <h4>GET THE MAC APP</h4>
                </div>
                <br/>
                <div align="center" hspace="10" vspace="10">
                    <a href="https://agentsatwork.app/#download"
                       target="_blank"
                       rel="noopener noreferrer"
                       className="start-free-button">
                        Download for macOS
                    </a>
                </div>
                <div className="divider"></div>
                <br/>
                <div style={{margin: '0 24px 0 24px'}}>
                    <h4>CONTROL YOUR AGENTS FROM IPHONE OR ANDROID</h4>
                </div>
                <br/>
                <div align="center" hspace="10" vspace="10">
                    <a href="https://apps.apple.com/us/app/agents-at-work-you-can-go/id6761508632"
                       target="_blank"
                       rel="noopener noreferrer">
                        <img src="/app_store.png" alt="itunes" height="36" hspace="5" vspace="5"/>
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.answersolutions.agentsatwork"
                       target="_blank"
                       rel="noopener noreferrer">
                        <img src="/google_play.svg" alt="google play" height="36" hspace="5" vspace="5"/>
                    </a>
                </div>
                <br/>
                <div className="divider"></div>
                <div style={{margin: '16px 24px 0 24px'}}>
                    <b>Full site</b>
                    <p>Tutorial, pricing, and the changelog live at{' '}
                        <a className="website-link" href="https://agentsatwork.app" target="_blank"
                           rel="noopener noreferrer">agentsatwork.app</a>.</p>
                </div>
            </div>
            <div align="center">
                <div className="fast_nav container">
                    <ul>
                        <li className="first">
                            <a href="#" role="button"
                               onClick={() => _this.props.navigate('Products')}>2026 © AnswerSolutions LLC</a>
                        </li>
                        <li className="selected">
                            <a href="#agents-at-work-product" role="button"
                               onClick={() => _this.props.navigate('AgentsAtWorkProduct')}>Agents At Work</a>
                        </li>
                        <li>
                            <a href="https://agentsatwork.app/privacy.html" target="_blank"
                               rel="noopener noreferrer">Privacy Policy</a>
                        </li>
                        <li>
                            <a href="https://agentsatwork.app/terms.html" target="_blank"
                               rel="noopener noreferrer">Terms</a>
                        </li>
                        <li>
                            <a href="https://agentsatwork.app/support.html" target="_blank"
                               rel="noopener noreferrer">Support</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    }
}

export default AgentsAtWorkProduct;
